export var DATE_FORMAT = 'dd.MM.yyyy';
export var DATE_FORMAT_SHORTEN = 'dd.MM.yy';
export var DATE_WITHOUT_YEAR_FORMAT = 'dd.MM.';
export var DAY_DATE_FORMAT = 'ccc dd.MM.yyyy';
export var DAY_SHORT_DATE_FORMAT = 'ccc dd.MM.';
export var MONTH_DATE = 'LLL dd';
export var TIME_FORMAT = 'HH:mm';
export var TIME_DURATION_FORMAT = 'hh:mm:ss';
export var DATE_TIME_FORMAT = "".concat(DATE_FORMAT, " ").concat(TIME_FORMAT);
export var SERVER_DATE_FORMAT = 'yyyy-MM-dd';
export var SERVER_DATE_TIME_FORMAT = "".concat(SERVER_DATE_FORMAT, " ").concat(TIME_FORMAT);
export var DAY_FORMAT = 'ccc';
export var DAY_LONG_FORMAT = 'cccc';
export var MAX_ALLOWED_SHIFTS = 6;
export var AMOUNT_OF_DATES_FOR_STATS = 7;
export var DEFAULT_INFINITE_LIST_LIMIT = 20;
export var RESERVATION_DROP_TYPE = 'RESERVATION';
export var RESERVATION_CHANGE_TABLE_DROP_TYPE = 'RESERVATION_CHANGE_TABLE';
export var CANVAS_TABLE_DROP_TYPE = 'CANVAS_TABLE';
export var AREA_LIST_ITEM_DROP_TYPE = 'AREA_LIST_ITEM_DROP_TYPE';
export var STAFF_TAG_LIST_ITEM_DROP_TYPE = 'STAFF_TAG_LIST_ITEM_DROP_TYPE';
export var MAINTENANCE_MODE = false;
export var RESERVATION_LIST_FILTERS_COLLAPSE_STATE = 'reservationListFiltersCollapseState';
export var RESERVATIONS_FILTERS_COLLAPSE_STATE = 'reservationsFiltersCollapseState';
export var RESERVATIONS_NOW_LINE_ENABLED = 'reservationsNowLineEnabled';
